module.exports = __webpack_public_path__ + "28583b6565e7e16e60bb0f9c80957395.pdf";